import {
  Iconography,
  IconographyThemes,
  Radio,
  Tooltip,
  TooltipPlacements,
} from "@hid-galaxy-ui/galaxy-react";
import "./CustomRadio.scss";

interface CustomRadioProps {
  fieldKey: string;
  fieldLabel: string;
  fieldValue: string;
  options: string[];
  isRequired?: boolean;
  handleChange: (key: string, value: string) => void;
}

const CustomRadio: React.FC<CustomRadioProps> = ({
  fieldKey,
  fieldLabel,
  fieldValue,
  options,
  isRequired = false,
  handleChange,
}) => {
  const radioListOptions = options?.map((option) => ({
    key: option,
    value: option,
  }));

  return (
    <div className="custom-radio-form-group">
      <div className="custom-radio-form-group-label">
        <label>
          {fieldLabel}
          {isRequired && <span className="required-asterisk">{" *"}</span>}
        </label>
        {!isRequired && fieldValue && (
          <span onClick={() => handleChange(fieldKey, "")}>
            <Tooltip
              message="Clear Selection"
              id={`tooltip-${fieldKey}`}
              placement={TooltipPlacements.Top}
            >
              <Iconography icon="circleX" theme={IconographyThemes.Error} />
            </Tooltip>
          </span>
        )}
      </div>
      <Radio
        key={fieldKey}
        selectedValue={fieldValue}
        displayMode="Vertical"
        radioList={radioListOptions || []}
        groupName={fieldKey}
        isRequired={isRequired}
        onChange={(e, key) => handleChange(fieldKey, key)}
      />
    </div>
  );
};

export default CustomRadio;
